import { createApi } from '@reduxjs/toolkit/query/react';
import deserialize from 'helpers/getroPropertyMapper';
import { networkBaseQueryV2 } from './queries';

export const sourcingApi = createApi({
  reducerPath: 'sourcingApi',
  baseQuery: networkBaseQueryV2,
  tagTypes: ['sourcingCampaigns'],
  endpoints: (builder) => ({
    getSourcingCampaigns: builder.query({
      query: ({ page = 1, perPage = 20, sharedListId, ...params } = {}) => ({
        url: '/sourcing_campaigns',
        params: {
          page,
          perPage,
          ...(sharedListId ? { sharedListId } : {}),
          ...params,
        },
      }),
      providesTags: ['sourcingCampaigns'],
      transformResponse: deserialize,
    }),
    getSourcingCampaign: builder.query({
      query: ({ id }) => ({
        url: `/sourcing_campaigns/${id}`,
      }),
      transformResponse: deserialize,
      providesTags: (result, error, { id }) => [{ type: 'sourcingCampaigns', id }],
    }),
  }),
});

export const {
  useGetSourcingCampaignsQuery,
  useLazyGetSourcingCampaignsQuery,
  useGetSourcingCampaignQuery,
  useLazyGetSourcingCampaignQuery,
} = sourcingApi;
